// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3e00S","blueColor":"Modal_blueColor__1HkXN","hideFooter":"Modal_hideFooter__K_mx6","customFooter":"Modal_customFooter__GOpst"};